/* eslint-disable */

import * as runtime from '../runtime';
import type {
  EventDto,
  EventFilterDataDto,
  EventRegistrationContextDto,
  EventRegistrationPaymentOptionsDto,
  GetEventRegistrationContextRequestDto,
  GetEventsNoAuthDto,
  PublicBookingScheduleRequestDto,
  PublicBookingScheduleResponseDto,
} from '../models';

export interface GetEventsFilterDataRequest {
  orgId: number;
  scope?: string;
}

export interface GetEventsNoAuthRequest {
  getEventsNoAuthDto: GetEventsNoAuthDto;
}

export interface GetEventBySlugRequest {
  orgIdOrSlug: string;
  slug: string;
}

export interface GetPublicBookingScheduleRequest {
  orgId: number;
  publicBookingScheduleRequestDto: PublicBookingScheduleRequestDto;
}

export interface GetEventRegistrationContextRequest {
  orgSlug: string;
  eventSlug: string;
  activityId: string;
  getEventRegistrationContextRequestDto: GetEventRegistrationContextRequestDto;
}

export interface GetPaymentOptionsNoAuthEventRequest {
  orgSlug: string;
  eventSlug: string;
  activityId: string;
}

export class EventApi extends runtime.BaseAPI {

  async getEventsFilterData(requestParameters: GetEventsFilterDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventFilterDataDto> {
    const queryParameters: any = {};

    if (requestParameters.scope !== undefined) {
      queryParameters['scope'] = requestParameters.scope;
    }

    const response = await this.request({
      path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/events-filter-data`,
      method: 'GET',
      headers: {},
      query: queryParameters,
    }, initOverrides);
    return response.json();
  }

  async getEventsNoAuth(requestParameters: GetEventsNoAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventDto>> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: '/events-no-auth',
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.getEventsNoAuthDto,
    }, initOverrides);
    return response.json();
  }

  async getEventBySlug(requestParameters: GetEventBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventDto> {
    const response = await this.request({ path: `/orgs/${encodeURIComponent(String(requestParameters.orgIdOrSlug))}/events/${encodeURIComponent(String(requestParameters.slug))}`, method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

  async getPublicBookingSchedule(requestParameters: GetPublicBookingScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicBookingScheduleResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/public-booking-schedule`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.publicBookingScheduleRequestDto,
    }, initOverrides);
    return response.json();
  }

  async getEventRegistrationContext(requestParameters: GetEventRegistrationContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventRegistrationContextDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/orgs/${encodeURIComponent(String(requestParameters.orgSlug))}/events/${encodeURIComponent(String(requestParameters.eventSlug))}/activities/${encodeURIComponent(String(requestParameters.activityId))}/registration-context`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.getEventRegistrationContextRequestDto,
    }, initOverrides);
    return response.json();
  }

  async getPaymentOptionsNoAuth(requestParameters: GetPaymentOptionsNoAuthEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventRegistrationPaymentOptionsDto> {
    const response = await this.request({ path: `/orgs/${encodeURIComponent(String(requestParameters.orgSlug))}/events/${encodeURIComponent(String(requestParameters.eventSlug))}/activities/${encodeURIComponent(String(requestParameters.activityId))}/payment-options-noauth`, method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

}
